import Nav from "./components/Nav";
import Animation from "./components/Animation";

const Critical = {
  nav: new Nav(),
  animation: new Animation(),
};

window.critical = Critical;
